module.exports = __webpack_public_path__ + "img/@work_img.349fd986.jpg";